var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":("order-" + _vm.order)}},[_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }